import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number | string, currency: string = 'INR'): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (currency === 'INR') {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(num);
  }
  return '$' + num.toFixed(2);
}

export function formatNumber(num: number | string): string {
  const n = typeof num === 'string' ? parseFloat(num) : num;
  return new Intl.NumberFormat('en-IN').format(n);
}

export function getStatusColor(status: string): string {
  const colors: Record<string, string> = {
    PENDING: 'bg-yellow-100 text-yellow-800',
    PROCESSING: 'bg-blue-100 text-blue-800',
    COMPLETED: 'bg-green-100 text-green-800',
    ACTIVE: 'bg-green-100 text-green-800',
    FAILED: 'bg-red-100 text-red-800',
    REJECTED: 'bg-red-100 text-red-800',
    CANCELLED: 'bg-gray-100 text-gray-800',
    APPROVED: 'bg-green-100 text-green-800',
    UNDER_REVIEW: 'bg-yellow-100 text-yellow-800',
    NOT_SUBMITTED: 'bg-gray-100 text-gray-600',
    RESUBMISSION_REQUIRED: 'bg-orange-100 text-orange-800',
    DEPOSIT: 'bg-blue-100 text-blue-800',
    WITHDRAWAL: 'bg-red-100 text-red-800',
    ROI_EARNING: 'bg-green-100 text-green-800',
    DIRECT_COMMISSION: 'bg-purple-100 text-purple-800',
    LEVEL_COMMISSION: 'bg-indigo-100 text-indigo-800',
    BONUS: 'bg-amber-100 text-amber-800',
    INVESTMENT: 'bg-cyan-100 text-cyan-800',
    TOPUP: 'bg-blue-100 text-blue-800',
    COMPOUND: 'bg-teal-100 text-teal-800',
    BONANZA_PAYOUT: 'bg-amber-100 text-amber-800',
    SUSPENDED: 'bg-red-100 text-red-800',
    INACTIVE: 'bg-gray-100 text-gray-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

export async function copyToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {}
  }
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.top = '-9999px';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  try {
    document.execCommand('copy');
    document.body.removeChild(textarea);
    return true;
  } catch {
    document.body.removeChild(textarea);
    return false;
  }
}